import declare from "dojo/_base/declare";
import NewSupplierRequest from "./NewSupplierRequest";

const NewFoodSKUSupplierRequest = declare(NewSupplierRequest, {
	fixedType: "DataPackageContainerType:FoodSKU",
	productField: "FoodSKUs",
});

export = NewFoodSKUSupplierRequest;